import { useState, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { Grid, Typography, TextField, Divider, Box, Radio, Button,CircularProgress } from '@mui/material';
import {
    setProductcompositionDashboardProductcompositionList,
    setCtitemList, setCompositiontemplateList
} from 'store/slice/PharmaSlice';
import { getListAPI as getCTitemList } from 'components/ctitem/CtitemAPI';
import { getListAPI as getCompTemplateList } from 'components/compositiontemplate/CompositiontemplateAPI';
import FieldView from 'core/components/layout/FieldView';
import { updateProductCTidAPI } from 'api/OmsOrdermgmtWebServices';
import { updateProductObj } from 'store/slice/PharmaSlice';
import SuccessMessage from 'core/components/SuccessMessage';

export default function ManagecompositionActionImpl() {
    const dispatch = useDispatch();
    const { compositiontemplateList, ctitemList } = useSelector((state) => state.pharmaslice);
    const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
    const [title, setTitle] = useState('');
    const [templateList, setTemplateList] = useState([]);
    const [filteredTemplateList, setFilteredTemplateList] = useState([]);
    const [selectedValue, setSelectedValue] = useState('');
    const [apiInProgress, setApiInProgress] = useState(false);
    const [errMsg, setErrMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');

    useEffect(() => {
        let templateArray = [];
        if (compositiontemplateList.lenght !== 0 && ctitemList.lenght !== 0) {
            for (let ii = 0; ii < compositiontemplateList.length; ii++) {
                let template = { id: compositiontemplateList[ii].id, title: compositiontemplateList[ii].title, ctItems: ctitemList.filter(ctObj => ctObj.ctid === compositiontemplateList[ii].id) }
                templateArray.push(template);
            }
        }
        setTemplateList(templateArray);
        setFilteredTemplateList(templateArray);

    }, [compositiontemplateList, ctitemList])

    useEffect(() => {
        if (compositiontemplateList.length === 0) getCompTemplateList(() => { }, getCompTemplateListSuccess)
        if (ctitemList.length === 0) getCTitemList(() => { }, getCTitemListSuccess);
    }, [])
    const getCTitemListSuccess = (list) => {
        dispatch(setCtitemList(list));
    }
    const getCompTemplateListSuccess = (list) => {
        dispatch(setCompositiontemplateList(list));
    }

    const handleFilter = (value) => {
        setTitle(value);
        let templateArray = [];
        for (let ii = 0; ii < templateList.length; ii++) {

            for (let jj = 0; jj < templateList[ii].ctItems.length; jj++) {
                if (templateList[ii].ctItems[jj].title.toLowerCase().includes(value.toLowerCase())) {
                    templateArray.push(templateList[ii]);
                    break;
                }
            }
        }
        setFilteredTemplateList(templateArray);
    }
    const handleChange = (value) => {
            setSelectedValue(value);
    };

    const apiSuccess = (response)=>{
        setApiInProgress(false);
        setSuccessMsg("Selected Composition is added to Product '"+productObj.title+"'");
        dispatch(updateProductObj(response.productInfo))
    }
    const apiFailure = (apiErrMsg)=>{
        setApiInProgress(false);
        setErrMsg(apiErrMsg);
    }
    const updateCTId = () =>{
        setErrMsg('')
        setApiInProgress(true);

        updateProductCTidAPI({
            productId:productObj.id,
            ctId:selectedValue
        }, apiSuccess, apiFailure)
    }
    const getComponent = () =>{
        if (apiInProgress) return <CircularProgress/>
        if (successMsg!=='') return <Grid item align="right"  padding={1}><SuccessMessage message={successMsg} /></Grid>

        return <Button variant="outlined" disabled={selectedValue==='' } onClick={()=>updateCTId()}>Add Composition</Button>
    }

    return (

        <Grid container direction="column" sx={{ justifyContent: "flex-end", alignItems: "flex-start", padding: 1, width: '100%' }}>
            <Grid item lg={12} sx={{ width: '100%', backgroundColor: 'white', padding: 1 }}>
                <TextField size="small"
                    label="Enter Composition Name to Search"
                    name="title"
                    value={title}
                    onChange={(e) => handleFilter(e.target.value)}
                    sx={{ width: '100%' }}
                />
            </Grid>
            <Grid container direction="row" lg={12} sx={{ width: '100%', backgroundColor: 'white', justifyContent:"flex-end", paddingRight:1 }}>
                <Typography color="textSecondary" gutterBottom variant="h6" sx={{fontSize:12}}><i>Select a Composition & Click on 'Add Composition' button</i></Typography>
            </Grid>

            <Grid item lg={12} sx={{ width: '100%' }}>
                <Box lg={12} sx={{ flexGrow: 1 }}>
                    <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: '50vh', minHeight: '50vh' }}>
                        {
                            filteredTemplateList && filteredTemplateList.map(ctObj => {
                                return (
                                    <Grid item lg={12} sx={{ width: '100%', backgroundColor: 'white', padding: 1, }}>
                                        <Grid container direction="row" sx={{ justifyContent: "space-between", alignItems: "center" }}>

                                            <Grid item lg={2} sx={{ padding: 2, }}>
                                                <Radio checked={selectedValue === ctObj.id} value={ctObj.id} name="radio-buttons" onChange={() => handleChange(ctObj.id)} inputProps={{ 'aria-label': 'A' }} />{ctObj.title}</Grid>
                                            <Grid item lg={10} sx={{ borderRadius: 2, borderLeft: '1px solid #91d5ff', borderRight: '1px solid #91d5ff' }}>
                                                <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "center", width: '100%' }}>
                                                    {
                                                        ctObj.ctItems.map(ctItemObj => {
                                                            return (<Grid item lg={3} sx={{}}>
                                                                <FieldView label={ctItemObj.title} value={ctItemObj.quantity + ' ' + ctItemObj.unitname}></FieldView>
                                                            </Grid>)
                                                        })
                                                    }
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid container direction="row" sx={{ justifyContent: "center", alignItems: "center" }}>
                                            <Grid item lg={12}><Divider /></Grid>
                                        </Grid>
                                    </Grid>
                                )
                            })}
                    </Grid>
                </Box>
            </Grid>
            <Grid container direction="row" justifyContent="flex-end" sx={{paddingTop:1}}>
            {getComponent()}
                
            </Grid>
        </Grid>

    )
}